/**
 * Utility for resolving Material-UI icon components by name
 * 
 * Usage:
 *   const IconComponent = getStatCardIcon("AttachMoneyIcon");
 *   return IconComponent ? <IconComponent fontSize="large" /> : null;
 */

import * as MuiIcons from "@mui/icons-material";

/**
 * Resolves a stat card icon name to its Material-UI component
 * Handles both formats: "AttachMoney" and "AttachMoneyIcon" (legacy)
 * 
 * @param iconName - Icon name (e.g., "AttachMoney" or "AttachMoneyIcon")
 * @returns React component or null if not found
 * 
 * @example
 * const icon = getStatCardIcon("AttachMoney");
 * return icon ? <icon fontSize="large" /> : null;
 */
export const getStatCardIcon = (
  iconName: string | undefined | null
): React.ComponentType<any> | null => {
  if (!iconName) return null;
  
  // Try direct lookup first
  let Icon = (MuiIcons as Record<string, any>)[iconName];
  
  // If not found and ends with "Icon", try without the suffix (backward compatibility)
  if (!Icon && iconName.endsWith("Icon")) {
    const nameWithoutSuffix = iconName.slice(0, -4); // Remove "Icon"
    Icon = (MuiIcons as Record<string, any>)[nameWithoutSuffix];
    
  }

  if (!Icon) {
    return null;
  }
  
  return Icon;
};
